/* eslint-disable max-len */
import JasmyQuestion from 'images/coin-pages/questions/jasmy.svg'

import { commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const jasmyPage: ICoinPageData = {
  title: 'coin_561',
  description: 'coin_562',
  // description:
  //   'Get a JasmyCoin loan. Receive up to 90% of your JASMY loan collateral in cash or crypto and continue holding. Borrow JasmyCoin instantly for an unlimited term and get extra funds in 15 minutes without selling your crypto.',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{
        __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'JasmyCoin (JASMY)' }),
      }}
    />
  ),
  questionsBlock: {
    image: JasmyQuestion,
    questions: [
      {
        title: 'coin_563',
        answer: 'coin_564',
      },
      {
        title: 'coin_565',
        answer: 'coin_566',
      },
      {
        title: 'coin_567',
        answer: 'coin_568',
      },
      {
        title: 'coin_569',
        answer: 'coin_570',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('JasmyCoin (JASMY)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_571',
        text: ['coin_573'],
      },
      {
        title: 'coin_572',
        text: ['coin_574'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-jasmy-coin-and-how-to-borrow-against-it/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2023/03/jasmy_blog.png',
        imageAlt: 'What is JASMY coin and how to borrow against it?',
      },
      {
        link: 'https://coinrabbit.io/blog/borrow-like-a-pro/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_3200/https://coinrabbit.io/blog/wp-content/uploads/2022/06/Ltt.png',
        imageAlt: 'Crypto Loans: Tips and Tricks',
      },
      {
        link: 'https://coinrabbit.io/blog/cryptocrash/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_3200/https://coinrabbit.io/blog/wp-content/uploads/2022/05/0.-Title.png',
        imageAlt: 'Surviving the Crypto Crash: How to take advantage of the crisis',
      },
    ],
  },
}
